// extracted by mini-css-extract-plugin
module.exports = {"table_row":"GroupSubscriptionMember_table_row__31RU-","table_cell":"GroupSubscriptionMember_table_cell__1zswb"};